module.exports = __webpack_public_path__ + "static/img/demand-widget-2.bfd3e766.png";